import ListQuestionAndAnswerSatiaScreen from "../ListQuestionAndAnswerSatiaScreen";
import {connect} from 'react-redux';
import axios from 'axios';
import {Platform} from "react-native";
import store from "../../../../../redux/store";
import {typeExport} from "../../../../../redux/store/type";
import HMAlert from "../../../../../customviews/HMAlert";
import i18n from "../../../../../I18n/i18n";

const mapStateToProps = (state) => ({
    // item_count: state.reducerSplashSatiaScreen.results.item_count,
    results: state.reducerListQuestionAndAnswerSatiaScreen.results,
    NoInternetDialog: state.reducerListQuestionAndAnswerSatiaScreen.NoInternetDialog,
    showLoading: state.reducerListQuestionAndAnswerSatiaScreen.showLoading,
    lazyload_end: state.reducerListQuestionAndAnswerSatiaScreen.lazyload_end,
    showRefresh: state.reducerListQuestionAndAnswerSatiaScreen.showRefresh,
    failed: state.reducerListQuestionAndAnswerSatiaScreen.failed,
    page: state.reducerListQuestionAndAnswerSatiaScreen.page,
    empty: state.reducerListQuestionAndAnswerSatiaScreen.empty,
    DataSplashSatiaScreen: state.reducerSplashSatiaScreen,
    resultsSet: state.reducerListQuestionAndAnswerSatiaScreen.resultsSet,
    isLoadingSet: state.reducerListQuestionAndAnswerSatiaScreen.isLoadingSet,
    NoInternetDialogSet: state.reducerListQuestionAndAnswerSatiaScreen.NoInternetDialogSet,
    ListFilter: state.reducerListQuestionAndAnswerSatiaScreen.ListFilter,
    id: state.reducerListQuestionAndAnswerSatiaScreen.id,
});

const mapDispatchToProps = (dispatch, getState) => ({
    callService: (url, params, type, typeConnection, page, item_count, id, func) => dispatch(callWebservice(getState, url, params, type, typeConnection, page, item_count, id, func)),
    callServiceAddFirst: (data, item_count) => dispatch(serviceActionAddFirstData(data, item_count)),
    callServiceChangeNotif: (data) => dispatch(serviceActionChangeNotif(data)),
    callserviceActionRefresh: () => dispatch(serviceActionRefresh()),
    callserviceActionListFilter: (data) => dispatch(serviceActionListFilter(data)),
    // callServiceSuccess: (data,page) => dispatch(serviceActionSuccess(data,page)),

})

const getDataDisatch = (dispatch, getState, url, params, type, typeConnection, page, item_count, id, func) => {
    let pagee;
    let url_send = "";

    switch (type) {
        case typeExport.TypeGetListQuestionAndAnswerSatiaScreen:
            url_send = typeExport.baseUrl + url + params + `&i=${page}`
            page === 1 ? dispatch(serviceActionRefresh()) : dispatch(serviceActionPending());

            break;
        case typeExport.TypeSetListQuestionAndAnswerSatiaScreen:
            url_send = typeExport.baseUrl + url + params;
            dispatch(serviceActionPendingSet(id))
            break;
        default:
    }


    let formData = new FormData();
    formData.append('token', store.getState().reducerSplashSatiaScreen.token == null ? '' : store.getState().reducerSplashSatiaScreen.token);
    formData.append('page', params.page);
    formData.append('serialTicket', params.serialTicket);
    formData.append('answerTicket', params.answerTicket);
    formData.append('typeResponse', params.typeResponse);

    formData.append('customer', store.getState().reducerSplashSatiaScreen.Account ? JSON.stringify(store.getState().reducerSplashSatiaScreen.Account) : null);

    const config = {
        headers: {
            "Content-Type": "multipart/form-data; charset=utf-8;",
            timeout: typeExport._TIMEOUT,
        }
    };

   // axios.post(url, formData, config)
    axios({
        method: 'post',
        url: url,
        data: formData,
        headers: {'Content-Type': 'multipart/form-data'},
        timeout: typeExport._TIMEOUT,

    })
        .then(async response => {

            switch (type) {

                case typeExport.TypeGetListQuestionAndAnswerSatiaScreen:


                    if (response.data.status) {


                        let data = response.data.result && response.data.result.data ? response.data.result.data : response.data.result;
                        // dispatch(serviceActionListFilter(response.data.result.searchItems));

                        if (data == null) data = []
                        /*   let arr = store.getState().reducerListQuestionAndAnswerSatiaScreen.results
                           if (page == 1) {
                               arr = data
                               global.list_menu_shahrdar=response.data.result.menu
                           } else {
                               if (arr.length > 0)
                               //    arr.push(data);
                                   arr = [...arr, ...data]
                               else
                                   arr = data
                           }*/

                        if (data.length == item_count) {
                            pagee = page + 1;
                            dispatch(serviceActionSuccess(data, pagee));
                        }

                        else {
                            (page === 1 & (data.length == 0)) ?
                                dispatch(serviceActionEmpty(page))
                                :
                                (pagee = page + 1, dispatch(serviceActionEnd(data, pagee)));
                        }


                        // let t=((getState === null || getState === undefined || getState === '') ? id : getState.route.params.data.type);
                        // await AsyngStorageClass.setAsyng(global.IdCity +typeExport.ListQuestionAndAnswerSatia +  t, arr)
                        // if (page == 1)
                        //     await AsyngStorageClass.setAsyng(global.IdCity +typeExport.ListQuestionAndAnswerSatiaFilter + t, response.data.result.searchItems)

                    } else {
                        dispatch(serviceActionError(response, page))

                        //alert(response.data.message)
                    }

                    break;

                case typeExport.TypeSetListQuestionAndAnswerSatiaScreen:
                    if (response.data.status) {
                        dispatch(serviceActionSuccessSet(response.data, id))


                        func ? func(1) : null;

                    }
                    else
                        dispatch(serviceActionErrorSet("error"))
                    HMAlert(
                        i18n.t('constant.message'),
                        response.data.message,
                        [
                            {
                                text: i18n.t('constant.ok'), onPress: () => {

                                }


                            },

                        ],
                        {cancelable: true}
                    )

                    // alert(response.data.message)
                    break;
                default:
                    console.log("default")
            }
        }).catch((e) => {
        switch (type) {
            case typeExport.TypeGetListQuestionAndAnswerSatiaScreen:
                dispatch(serviceActionError(e, page))

                break;
            case typeExport.TypeSetListQuestionAndAnswerSatiaScreen:
                dispatch(serviceActionErrorSet(e))
                break;
            default:
        }
    })
}


export const callWebservice = (getState, url, params, type, typeConnection, page, item_count, id, func) => {

    return dispatch => {


        // NetInfo.getConnectionInfo().done(
        //     (isConnected) => {
        //         if (isConnected) {
        //             getDataDisatch(dispatch, getState, url, params, type, typeConnection, page, item_count, id, func);
        //         } else {
        //             dispatch(serviceActionError("No Internet Connection", page));
        //
        //         }
        //     }
        // )

        if (store.getState().reducerSplashSatiaScreen.Connection) {
            getDataDisatch(dispatch, getState, url, params, type, typeConnection, page, item_count, id, func);
        } else {
            switch (type) {
                case typeExport.TypeGetListQuestionAndAnswerSatiaScreen:
                    dispatch(serviceActionError('error_Connection', page))

                    break;
                case typeExport.TypeSetListQuestionAndAnswerSatiaScreen:
                    dispatch(serviceActionErrorSet('error_Connection'))
                    break;
                default:
            }
        }


    }
}

export const serviceActionPendingSet = (id) => ({
    type: typeExport.SetListQuestionAndAnswerSatiaScreen_SERVICE_PENDING,
    NoInternetDialogSet: false,
    isLoadingSet: true,
    resultsSet: null,
    id: id

})

export const serviceActionErrorSet = (error) => ({
    type: typeExport.SetListQuestionAndAnswerSatiaScreen_SERVICE_ERROR,
    NoInternetDialogSet: true,
    isLoadingSet: false,
    error: error
})

export const serviceActionSuccessSet = (data, id) => ({
    type: typeExport.SetListQuestionAndAnswerSatiaScreen_SERVICE_SUCCESS,
    NoInternetDialogSet: false,
    isLoadingSet: false,
    resultsSet: data,
    id: id,
})
export const serviceActionPending = () => ({
    type: typeExport.ListQuestionAndAnswerSatiaScreen_SERVICE_PENDING,
    NoInternetDialog: false,
    showRefresh: false,
    showLoading: true,
    lazyload_end: false,
    empty: false,
    failed: false
})

export const serviceActionError = (error, page) => ({
    type: typeExport.ListQuestionAndAnswerSatiaScreen_SERVICE_ERROR,
    NoInternetDialog: true,
    showRefresh: false,
    showLoading: false,
    lazyload_end: true,
    empty: false,
    failed: true,
    page: page,
    error: error
})
export const serviceActionRefresh = () => ({
    type: typeExport.ListQuestionAndAnswerSatiaScreen_SERVICE_REFRESH,
    results: [],
    NoInternetDialog: false,
    showRefresh: true,
    lazyload_end: false,
    showLoading: false,
    empty: false,
    failed: false,
    page: 1,

})
export const serviceActionSuccess = (data, page) => ({

    type: typeExport.ListQuestionAndAnswerSatiaScreen_SERVICE_SUCCESS,
    NoInternetDialog: false,
    results: data,
    //  resultsFavourite: data,
    showRefresh: false,
    lazyload_end: false,
    showLoading: true,
    empty: false,
    failed: false,
    page: page
})
export const serviceActionEnd = (data, page) => ({
    type: typeExport.ListQuestionAndAnswerSatiaScreen_SERVICE_END,
    results: data,
    NoInternetDialog: false,
    showRefresh: false,
    lazyload_end: true,
    showLoading: false,
    empty: false,
    failed: false,
    page: page
})
export const serviceActionEmpty = (page) => ({
    type: typeExport.ListQuestionAndAnswerSatiaScreen_SERVICE_Empty,
    NoInternetDialog: false,
    showRefresh: false,
    lazyload_end: true,
    showLoading: false,
    empty: true,
    failed: false,
    page: page
})
export const serviceActionAddFirstData = (data, item_count) => ({
    type: typeExport.ListQuestionAndAnswerSatiaScreen_SERVICE_ADD_FIRST_DATA,
    results: data,
    NoInternetDialog: false,
    showRefresh: false,
    lazyload_end: (data.length < item_count) ? true : false,
    showLoading: false,
    empty: data.length == 0 ? true : false,
    failed: false,
    page: 2
})

export const serviceActionChangeNotif = (data) => ({
    type: typeExport.ListQuestionAndAnswerSatiaScreen_SERVICE_CHANGE_NOTIF,

    data: data
})
export const serviceActionAddSubList = (data) => ({

    type: typeExport.ListQuestionAndAnswerSatiaScreen_SERVICE_AddSubList,

    data: data,

})

export const serviceActionListFilter = (data) => ({

    type: typeExport.ListQuestionAndAnswerSatiaScreen_SERVICE_LIST_FILTER,

    ListFilter: data,

})
export default connect(mapStateToProps, mapDispatchToProps)(ListQuestionAndAnswerSatiaScreen);
